import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { RoleSelectorComponent } from './components/role-selector/role-selector.component';

@NgModule({
  declarations: [RoleSelectorComponent],
  imports: [SharedModule, ReactiveFormsModule, FormsModule, CommonModule, NgSelectModule],
  exports: [RoleSelectorComponent],
})
export class RoleSelectorModule {}
